import React, { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import logo from "../../Assets/bricknbarLogo.png";
import { useNavigate } from "react-router-dom";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <nav className="bg-white text-[#3d3d3f] shadow-md sticky top-0 z-50">
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div
            className="flex-shrink-0 flex items-center space-x-2 cursor-pointer"
            onClick={() => navigate("/")}
          >
            <img
              src={logo}
              alt="BricksNBar Logo"
              className="h-8 w-auto object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            <button
              onClick={() => navigate("/")}
              className="hover:text-[#ae3e34] font-medium transition duration-200"
            >
              Home
            </button>
            <button
              onClick={() => navigate("/about")}
              className="hover:text-[#ae3e34] font-medium transition duration-200"
            >
              About
            </button>
            <button
              onClick={() => navigate("/contact")}
              className="hover:text-[#ae3e34] font-medium transition duration-200"
            >
              Contact
            </button>
          </div>

          {/* Mobile Hamburger */}
          <div className="md:hidden">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-[#3d3d3f] focus:outline-none"
            >
              {mobileMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white px-4 py-4 space-y-2 text-[#3d3d3f]">
          <button
            onClick={() => {
              navigate("/");
              setMobileMenuOpen(false);
            }}
            className="block w-full text-left hover:text-[#ae3e34] font-medium"
          >
            Home
          </button>
          <button
            onClick={() => {
              navigate("/about");
              setMobileMenuOpen(false);
            }}
            className="block w-full text-left hover:text-[#ae3e34] font-medium"
          >
            About
          </button>
          <button
            onClick={() => {
              navigate("/contact");
              setMobileMenuOpen(false);
            }}
            className="block w-full text-left hover:text-[#ae3e34] font-medium"
          >
            Contact
          </button>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
